module.exports = __webpack_public_path__ + "img/onuorah.fb4501de.png";